module.exports = __webpack_public_path__ + "static/media/cooler.d28cc5e6.png";